<template>
    <div class="keyword_box">
        <div class="key_topTit">Venue Fees</div>
        <div>
			<el-table
			:data="tableData"
			border
			class="roster_table"
			style="width: 100%">
				<el-table-column
				prop="month"
				align="left"
				label-class-name="roster_th"
				class-name="roster_row"
				label="MONTH">
				</el-table-column>
				<el-table-column
				prop="received"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="RECEIVED">
				</el-table-column>
				<el-table-column
				prop="uncollected"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="UNCOLLECTED">
				</el-table-column>
				<el-table-column
				prop="address"
				align="right"
				label-class-name="roster_th"
				class-name="roster_row"
				label="OPERATION">
					<template slot-scope="scope">
                        <div class="key_tableBtn_group">
                            <div class="key_payBtn" @click="payFee(scope.row)">Start Process</div>
                        </div>
					</template>
				</el-table-column>
                <template slot="empty">
                    <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                    <div v-else>-</div>
                </template>
			</el-table>
			<div class="ros_footerPage">
				<el-pagination
					class="my_pageSel"
					:current-page.sync="page"
					layout="prev, pager, next"
                    @current-change='changePage'
					:page-size="10"
					:total="total">
				</el-pagination>
			</div>
		</div>
    </div>
</template>

<script>
import api from '../../api/fee'
export default {
    data() {
        return {
			tableData:[],
			page:1,
			size:10,
			total:0,
			loading:false
        }
	},
	mounted() {
		this.getList()
	},
    methods: {
        payFee(value){
            window.sessionStorage.setItem('month',value.month)
            this.$router.push({path:'/feeDetail',query:{month:value.month,received:value.received,uncollected:value.uncollected}})
		},
        changePage(page){
            this.page=page
            this.getList()
        },
		getList(){
            this.loading=true
            let pat={
                pageNum:this.page,
                pageSize:this.size
            }
            api.getStatisticsList({params:pat,callback:res=>{
                this.loading=false
                let {code,message,data}=res.data;
                this.loading2=false;
                if(code==0){
                    this.tableData=data.list;
                    this.total=data.total;
                    this.tableData.forEach(item=>{
                        item.date=Utils.timeFotmatYMD(item.date)
                    })
                }else{
                    this.$box.alert('', res.data.message, 'error')
                }
            }})
        }
    },
}
</script>

<style lang="scss">
    .keyword_box{
        .key_topTit{
            height:33px;
            font-size:24px;
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:33px;
            -webkit-text-stroke:1px rgba(255,255,255,1);
            margin-bottom: 40px;
        }
		.ros_footerPage{
			display: flex;
			justify-content: center;
        }
        .key_tableBtn_group{
            display: flex;
            justify-content: flex-end;
        }
        .key_payBtn{
            width:140px;
            height:40px;
            background:rgba(21,28,39,1);
            border:1px solid #fff;
            font-size:18px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            cursor: pointer;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/fee/feelist.vue